var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardDropOff({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 110,
    viewBox: "0 0 111 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.507812,
    width: 110,
    height: 110,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.0667 38.0327C79.4 36.066 77.5333 34.666 75.3333 34.666H38.6667C36.4667 34.666 34.6333 36.066 33.9333 38.0327L27 57.9993V84.666C27 86.4994 28.5 87.9994 30.3333 87.9994H33.6667C35.5 87.9994 37 86.4994 37 84.666V81.3327H77V84.666C77 86.4994 78.5 87.9994 80.3333 87.9994H83.6667C85.5 87.9994 87 86.4994 87 84.666V57.9993L80.0667 38.0327ZM39.8333 41.3327H74.1333L77.6 51.3327H36.3667L39.8333 41.3327ZM80.3333 74.666H33.6667V57.9993H80.3333V74.666Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 71.332C44.7614 71.332 47 69.0935 47 66.332C47 63.5706 44.7614 61.332 42 61.332C39.2386 61.332 37 63.5706 37 66.332C37 69.0935 39.2386 71.332 42 71.332Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72 71.332C74.7614 71.332 77 69.0935 77 66.332C77 63.5706 74.7614 61.332 72 61.332C69.2386 61.332 67 63.5706 67 66.332C67 69.0935 69.2386 71.332 72 71.332Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDropOff);
export default __webpack_public_path__ + "static/media/cardDropOff.32b2f4dfaf461417118fc4af9658e471.svg";
export { ForwardRef as ReactComponent };